import { render, staticRenderFns } from "./teacherinfoadd.vue?vue&type=template&id=6c951004&scoped=true"
import script from "./teacherinfoadd.vue?vue&type=script&lang=js"
export * from "./teacherinfoadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c951004",
  null
  
)

export default component.exports